import { StandardEvents } from '@shopify/events';

/**
 * Barra de metas de la ficha (envío gratis y descuentos).
 *
 * Muestra el estado actual del carrito (subtotal antes de descuentos de
 * pedido), sin sumar el producto que se está mirando. Cuando el carrito
 * cambia (p. ej. al agregar este producto), se lo pasa a <mr-tiers>, que
 * repinta mensaje y barra.
 */
class MrShippingBar extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleCartUpdate = (event) => {
    event.promise
      ?.then(({ cart }) => {
        // Subtotal antes de descuentos de pedido; si el evento no lo trae, /cart.js
        const subtotal = cart?.items_subtotal_price;
        if (typeof subtotal === 'number') return subtotal;
        return fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`)
          .then((response) => response.json())
          .then((fresh) => fresh?.items_subtotal_price);
      })
      .then((subtotal) => {
        const tiers = this.querySelector('mr-tiers');
        if (typeof subtotal === 'number' && tiers instanceof HTMLElement) tiers.dataset.subtotal = String(subtotal);
      })
      .catch(() => {
        /* el tema ya informa del error del carrito */
      });
  };
}

if (!customElements.get('mr-shipping-bar')) {
  customElements.define('mr-shipping-bar', MrShippingBar);
}
